import { embeddedRuntime } from '@/config'
import { session } from '@/composables/useSession'

export const loadNavigationComponent = async () => {
  if (embeddedRuntime() || !session.features.zendeskUiNavigation) return

  try {
    await import('../../app-navigation/build/static/js/main.js' as string)
    console.info('[ZUI] Navigation component loaded')
  } catch (error) {
    console.warn('[ZUI] Failed to load navigation component:', error)
  }
}
